import React from 'react'
import { PurchaseContractErrors } from '../../pages/Hub/Plans/Positions/Edit/types'

type Props = {
    value: Date
    onChange: (value: Date, isRetry: boolean) => void
    theme: string
    error?: PurchaseContractErrors
}

const _getDateAsString = (date: Date): string => {
    const month = date.getMonth() + 1
    const day = date.getDate()

    const addLeadingZero = (value: number): string => {
        return (value < 10 ? '0' : '') + value
    }

    return (
        date.getFullYear() +
        '-' +
        addLeadingZero(month) +
        '-' +
        addLeadingZero(day)
    )
}

const CurrencyDateSelector: React.FC<Props> = (props) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value

        // Проверяем: строка должна быть формата YYYY-MM-DD
        if (!value || value.length < 10) return

        const parsedDate = new Date(value)

        // Проверяем: дата должна быть валидной
        if (isNaN(parsedDate.getTime())) return

        // Всё ок — вызываем onChange
        props.onChange(parsedDate, false)
    }

    return (
        <>
            <span className="form-label">Дата курса валюты</span>
            <input
                type="date"
                className={`form-select ${
                    props?.error?.exchange_rate_date
                        ? 'border border-[#ff5353] dark:border-[#C15C5C]'
                        : ''
                }`}
                style={{
                    colorScheme: props.theme === 'dark' ? 'dark' : 'light',
                }}
                value={_getDateAsString(props.value)}
                onChange={handleChange}
            />
        </>
    )
}

export default CurrencyDateSelector
